<template>
  <main class="produtos">
    <div class="container px-2 px-md-3 position-relative">
      <div class="sombra-direita"></div>
      <div class="sombra-esquerda"></div>
      <div class="principal my-4">
          <section id="tab_produtos" class="produtos">
              <header class="header-cnastore p-3 d-flex justify-content-between align-items-center">
                  <img src="../../../public/img/logo-cnastore.svg" width="200" />
                  <a href="/"
                     alt="Carrinho"
                     title="Carrinho"
                     class="px-5 d-flex flex-column">
                      <span class="material-icons"> shopping_cart </span>
                      <span class="small">Ir para o carrinho</span>
                  </a>
              </header>
              <div class="d-flex flex-row justify-content-center align-items-center my-3 w-100 px-3">
                  <div class="w-100">
                          <input type="text" class="form-control" name="nome" v-model="model.nome" value="" placeholder="Pesquisar por Nome" @change="getProdutosPorNome()" />
                  </div>
                  <div>
                      <button class="btn btn-sm btn-buscar" @click="getProdutosPorNome()">BUSCAR</button>
                  </div>
              </div>
              <div>
                  <ul class="nav nav-pills d-flex justify-content-center">
                      <li class="nav-item flex-fill d-flex justify-content-center"
                          v-for="item in menu">
                          <a href="#" class="nav-link" @click="getProdutos(item)">
                              {{
                  item.nome
                              }}
                          </a>
                      </li>
                  </ul>
              </div>
              <div style="background-color:#EEEEEE;text-align:right" v-if="categoriaSelecionada=='PARCEIROS'"><!-- Banner somente para parceiros -->
                  <a href="http://www.innovationstore.com.br/cna/" target="_blank">
                      <img src="../../assets/images/banner-cna.png" />
                  </a>
              </div>
              <div class="vitirine-material-didatico">
                  <div class="container py-3 vitrine-produtos">
                      <h5>
                          <strong>{{ categoriaSelecionada }}</strong>
                      </h5>
                      <hr class="mt-1" />
                      <div class="row p-2">
                          <div class="mb-4 col-md-3" v-for="item in produto.items">
                              <div class="card h-100 produto">
                                  <div class="img-produto overflow-hidden">
                                      <img class="card-img-produto"
                                           :src="item.produto.imagem"
                                           width="100%"
                                           :alt="item.produto.nome" />
                                  </div>
                                  <div class="card-body p-2 text-center">
                                      <p class="card-text">{{ item.produto.nome }}</p>
                                      <span class="descricao-produto d-flex flex-column">
                                          <p v-html="item.produto.descricao"></p>
                                          <span class="text-right w-100">
                                              <a @click="showModal(item)">Saiba mais...</a>
                                          </span>
                                      </span>

                                      <p class="card-text mt-3">
                                          Preço a Prazo:
                                          <strong> {{ item.precoTotalaPrazo }}</strong>
                                      </p>
                                      <p class="card-text">
                                          Preço a Vista:<strong> {{ item.precoTotalaVista }}</strong>
                                      </p>
                                      <div style="display: inline-block" v-if="item.produto.quantidade>0">
                                          <button class="btn btn-sm btn-danger"
                                                  @click="AddRemoveItem(item, 'remove')">
                                              <i class="fa fa-minus"></i>
                                          </button>
                                          <input class="mx-2 text-center"
                                                 style="width: 45px"
                                                 v-model="item.produto.unidades"
                                                 v-if="qtdUnidades"
                                                 @change="updateUnidade(item)"
                                                 type="number" />
                                          <input class="mx-2 text-center"
                                                 style="width: 45px"
                                                 v-model="item.unidades"
                                                 v-if="!qtdUnidades"
                                                 @change="updateUnidade(item)"
                                                 type="number" />
                                          <button class="btn btn-sm btn-success"
                                                  @click="AddRemoveItem(item, 'add')">
                                              <i class="fa fa-plus"></i>
                                          </button>
                                      </div>
                                  </div>
                                  <div class="card-footer text-muted p-0 mt-3" v-if="item.produto.quantidade>0">
                                      <button type="button"
                                              @click="comprar(item)"
                                              class="btn btn-raised btn-success btn-block m-0">
                                          Comprar
                                      </button>
                                  </div> 
                                  <div v-else class="card-footer text-muted p-0 mt-3">
                                      <button class="btn btn-raised btn-danger btn-block m-0">
                                          Produto indisponível
                                      </button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="card-block no-padding" v-if="produto.total > 0">
                  <pagination :total="produto.total"
                              :page-size="filterProduto.pageSize"
                              :callback="executePageChanged"></pagination>
              </div>
              <!-- Botão ir para revisão dos itens-->
              <div v-if="exibirBotaoRevisaoItens" class="col-md-3">
                  <!--<button type="button" class="btn btn-raised btn-danger btn-block m-0">IR PARA REVISÃO DOS ITENS</button>-->
                  <a href="/home" class="btn btn-raised btn-danger btn-block m-0">
                      IR PARA REVISÃO DOS ITENS
                  </a>
              </div>
          </section>
      </div>
    </div>

    <b-modal
      ref="detalhe-produto"
      size="lg"
      hide-footer
      title="Detalhes do produto"
      v-model="exibirModalProduto"
    >
      <b-media>
        <template #aside>
          <img
            :src="modelProduto.produto.imagem"
            alt="Media Aside"
            class="img-produto-modal"
          />
        </template>
        <h5
          class="mt-0 text-danger d-flex justify-content-between align-items-center"
        >
            <span>{{ modelProduto.produto.nome }}</span>
          <!--<span
            class="badge bg-danger text-white shadow-none font-weight-normal mb-1"
            >Preço Un: R$ {{ modelProduto.precoUnitarioBase }}</span
          >-->
        </h5>
        <div
          class="valores-qauntidade bg-light p-2 d-flex justify-content-between align-items-center mb-2"
        >
          <div style="display: inline-block" v-if="modelProduto.produto.quantidade>0">
            <button
              class="btn btn-sm btn-danger"
              @click="AddRemoveItem(modelProduto, 'remove')"
            >
              <i class="fa fa-minus"></i>
            </button>
            <input
              class="mx-2 text-center"
              style="width: 45px"
              v-model="modelProduto.produto.unidades"
              v-if="qtdUnidades"
              @change="updateUnidade(modelProduto)"
              type="number"
            />
            <input
              class="mx-2 text-center"
              style="width: 45px"
              v-model="modelProduto.produto.unidades"
              v-if="!qtdUnidades"
              @change="updateUnidade(modelProduto)"
              type="number"
            />
            <button
              class="btn btn-sm btn-success"
              @click="AddRemoveItem(modelProduto, 'add')"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
          <span class="card-text">
            Total a Prazo: <strong>{{ modelProduto.precoTotalaPrazo }}</strong>
          </span>

          <div v-if="modelProduto.produto.quantidade>0">
              <button type="button"
                      @click="comprar(modelProduto)"
                      class="btn btn-raised btn-success m-0 float-right">
                  Comprar
              </button>
          </div>
          
        </div>
        <p class="produto-descricao-texto" v-html="modelProduto.produto.descricao"></p>
      </b-media>
    </b-modal>
  </main>
</template>
<script>
import { Api } from "@/common/api";
import Auth from "@/common/auth";
import Cache from "@/common/cache";
import base from "@/common/base";
import Global from "@/common/global";

export default {
  name: "CnaStore",
  mixins: [base],
  data() {
    return {
      categoriaSelecionada: "Selecione uma categoria",
      menu: [],
      categoria: {},
        modelProduto: {
            produto: {}
        },
      qtdUnidades: true,
      exibirBotaoRevisaoItens: false,
        exibirModalProduto: false,
        model: {
            nome:""
        },
      produto: {
        total: 0,
        items: [],
      },
      filterProduto: {
        pageSize: 20,
        pageIndex: 1,
        isPagination: true,
      },
    };
  },
  computed: {},
  methods: {
      showModal(model) {
          //console.log("model modal", model);
      this.modelProduto = model;
      this.exibirModalProduto = true;
    },

    updateUnidade(item) {
        if (item.produto.unidades < 1) {
            item.produto.unidades = 1;
      }
        this.updateQtdUnidade();
        //item.precoTotal = Intl.NumberFormat("pt-BR", {
        //    style: "currency",
        //    currency: "BRL",
        //}).format(item.precoUnitarioBase * item.unidades);
      item.precoTotalaVista = Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(item.valor * item.produto.unidades);
      item.precoTotalaPrazo = Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
      }).format(item.valorParcelado * item.produto.unidades);
    },
    updateQtdUnidade: function () {
      this.qtdUnidades = false;
      //this.showLoading();
      setTimeout(() => {
        this.qtdUnidades = true;
        //this.hideLoading();
      }, 500);
    },
    AddRemoveItem(item, addOrRemove) {
      //console.log(item.unidades);
      //console.log(addOrRemove);
      if (addOrRemove == "add") {
          item.produto.unidades = parseInt(item.produto.unidades) + 1;
        this.updateQtdUnidade();
      } else {
          if (parseInt(item.produto.unidades) > 1) {
              item.produto.unidades = parseInt(item.produto.unidades) - 1;
          this.updateQtdUnidade();
        }
      }
      //item.precoTotal = Intl.NumberFormat("pt-BR", {
      //  style: "currency",
      //  currency: "BRL",
      //}).format(item.precoUnitarioBase * item.unidades);
        item.precoTotalaVista = Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(item.valor * item.produto.unidades);
        item.precoTotalaPrazo = Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
        }).format(item.valorParcelado * item.produto.unidades);
    },

    getMenu() {
      new Api("CategoriaProduto")
        .get({ attributeBehavior: "MenuCnaStore", ativo: true })
        .then((result) => {
          if (result.dataList) {
              this.menu = result.dataList;
             
              this.getProdutos(this.menu[0]);//Primeira categoria
              
          }
          this.hideLoading();
        });
    },
    getProdutos(categoria) {
      this.showLoading();
      this.categoriaSelecionada = categoria.nome.toUpperCase();
      this.categoria = categoria;

      if (
        this.filterProduto.categoriaProdutoId !=
        this.categoria.categoriaProdutoId
      ) {
        this.filterProduto.pageIndex = 1;
        this.produto.total = 0;
      }

      this.filterProduto.categoriaProdutoId =  this.categoria.categoriaProdutoId;
        this.filterProduto.Ativo = true;
        this.filterProduto.tipoProdutoId = 3;//Tipo produto CNAStore
        this.filterProduto.nome = "";
        this.model.nome = "";
      new Api("PoliticaComercialProduto").get(this.filterProduto).then(
          (result) => {
              //console.log("produtos",result.dataList);
          if (result.dataList) {
            this.produto.items = result.dataList;
            this.produto.total = result.summary.total;
            this.produto.items.map((item, index) => {
              item.produto.unidades = 1;
              //item.precoTotal = Intl.NumberFormat("pt-BR", {
              //  style: "currency",
              //  currency: "BRL",
              //}).format(item.precoUnitarioBase * item.unidades);
                item.precoTotalaVista = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(item.valor * item.produto.unidades);
                item.precoTotalaPrazo = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                }).format(item.valorParcelado * item.produto.unidades);
            });
          }
          this.hideLoading();
        },
        (err) => {
          this.hideLoading();
        }
      );
      },

      getProdutosPorNome() {
          this.showLoading();
          //this.categoriaSelecionada = categoria.nome.toUpperCase();
          //this.categoria = categoria;

          //if (
          //    this.filterProduto.categoriaProdutoId !=
          //    this.categoria.categoriaProdutoId
          //) {
          //    this.filterProduto.pageIndex = 1;
          //    this.produto.total = 0;
          //}

          //this.filterProduto.categoriaProdutoId = this.categoria.categoriaProdutoId;
          this.filterProduto.Ativo = true;
          this.filterProduto.tipoProdutoId = 3;//Tipo produto CNAStore
          this.filterProduto.nome = this.model.nome;
          this.filterProduto.categoriaProdutoId = "";
          new Api("PoliticaComercialProduto").get(this.filterProduto).then(
              (result) => {
                  if (result.dataList) {
                      //console.log("produtos por nome", result.dataList);
                      this.produto.items = result.dataList;
                      this.produto.total = result.summary.total;
                      this.produto.items.map((item, index) => {
                          item.produto.unidades = 1;
                          //item.precoTotal = Intl.NumberFormat("pt-BR", {
                          //    style: "currency",
                          //    currency: "BRL",
                          //}).format(item.precoUnitarioBase * item.unidades);
                          item.precoTotalaVista = Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                          }).format(item.valor * item.produto.unidades);
                          item.precoTotalaPrazo = Intl.NumberFormat("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                          }).format(item.valorParcelado * item.produto.unidades);
                      });
                  }
                  this.hideLoading();
              },
              (err) => {
                  this.hideLoading();
              }
          );
      },

      comprar(produto) {
          //console.log("lista...",produto);
      var model = {
        produtoId: produto.produtoId,
        unidades: produto.produto.unidades,
      };
      new Api("PessoaProduto/AdicionarPessoaProdutoCnaStore").post(model).then(
        (result) => {
          this.defaultSuccessResult("Produto Adicionado ao carrinho!");
          this.exibirBotaoRevisaoItens = true;
          this.exibirModalProduto = false;
        },
        (err) => {
          this.defaultErrorResult(err);
          this.exibirBotaoRevisaoItens = false;
        }
      );
    },
    executePageChanged: function (index) {
      //this.filterProduto.pageIndex = 1;

      this.filterProduto = this.defaultPageChanged(this.filterProduto, index);
      this.getProdutos(this.categoria);
    },
  },
  async mounted() {
    this.showLoading();
     this.getMenu();      
  },
};
</script>
<style lang="scss">
.principal {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 1) 30%
  );
}

.header-cnastore {
  a {
    color: #c9252b;
    transition: all 0.5s ease-in-out;
    text-decoration: none !important;
    text-align: center;

    span {
      font-size: 48px;

      &.small {
        font-size: 12px;
      }
    }

    &:hover {
      color: #ff6b70;
    }
  }
}

.nav-item {
  color: #c9252b;
  font-weight: 500 !important;
  border-bottom: 1px solid #c9252b !important;
  border-top: 1px solid #c9252b !important;
  transition: all 0.2s ease-in-out;

  a {
    color: currentColor;
    display: block;
    font-size: 14px !important;

    padding: 8px 23px 8px 16px !important;

    &:hover {
      color: #fff;
    }
  }

  &:hover {
    background-color: #c9252b;
    color: #fff;
    border-bottom: 3px solid #c9252b !important;
    border-top: 3px solid #c9252b !important;
    margin-bottom: -3px;
    margin-top: -3px;
    font-weight: bold !important;
  }
}

.descricao-produto {
  margin-bottom: 10px;
  p {
    overflow: hidden; // Removendo barra de rolagem
    text-overflow: ellipsis; // Adicionando "..." ao final
    display: -webkit-box;
    -webkit-line-clamp: 2; // Quantidade de linhas
    -webkit-box-orient: vertical;
    color: rgb(102, 102, 102);
    font-size: 12px;
    margin-bottom: 0;
  }

  a {
    color: #c9252b !important;
    font-size: 10px;
    cursor: pointer;
  }
}

.img-produto-modal {
  max-width: 255px;
}

.badge {
  height: 26px;
  margin-left: 10px;

  &.bg-danger {
    color: #ffffff;
    font-weight: normal;
    border-radius: 5px;
  }
}

.produto-descricao-texto {
  font-size: 14px;
}

    .btn.btn-buscar {
        background-color: #c9252b;
        color:#ffffff;
        margin-top:8px;
    }
</style>